// utils/isOwner.js
const norm = (v) => String(v ?? "").trim().toLowerCase();
const truthy = (v) => v === true || v === 1 || v === "1";

/**
 * Decide if the current user is the "Owner" (the only special role).
 * We try in this order:
 * 1) JWT claim isOwner (if you add it on login)
 * 2) Match roleId to a role from DB marked IsDefaultUser = true
 * 3) Fallback: role name contains "owner"
 */
export const isOwner = (authData, roles = []) => {
  if (!authData) return false;

  // 1) explicit claim (add this from server if you can)
  if (truthy(authData.isOwner)) return true;

  // 2) DB role list: IsDefaultUser flag or name contains 'owner'
  const roleId = String(authData.roleId ?? "");
  const fromDb = Array.isArray(roles)
    ? roles.find((r) => String(r.id ?? r.Id) === roleId)
    : null;

  if (fromDb) {
    const isDefault = truthy(fromDb.isDefaultUser ?? fromDb.IsDefaultUser);
    if (isDefault) return true;
    const nm  = norm(fromDb.name ?? fromDb.Name);
    const nnm = norm(fromDb.normalizedName ?? fromDb.NormalizedName);
    const base= norm(fromDb.baseRoleName ?? fromDb.BaseRoleName);
    const desc= norm(fromDb.description ?? fromDb.Description);
    if ([nm, nnm, base, desc].some((t) => t.includes("owner"))) return true;
  }

  // 3) fallback to JWT/display role name
  const roleName = norm(authData.role);
  return roleName.includes("owner");
};
